import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-quote",
  templateUrl: "./med-icon-quote.component.html",
})
export class MedIconQuoteComponent extends SvgMixinComponent {}
